module.exports = __webpack_public_path__ + "img/agreement.0fae6456.png";